package dev.lingvo.site.pages.app.projects.slug.screenshots

import androidx.compose.runtime.Composable
import dev.lingvo.shared.DeviceClass
import dev.lingvo.site.api.Session
import dev.lingvo.site.state.ProjectAuthority

/** Canvas URL selection is shared with comments, including a single selected layer and narrow-screen slot changes. */
@Composable
internal fun DesignCanvasReview(
    data: DesignPageData, controller: DesignAutosaveController, params: ScreenshotsAreaState,
    device: DeviceClass, locale: String, canWrite: Boolean, onParams: (ScreenshotsAreaState) -> Unit,
) {
    val keys = controller.document?.boards?.firstOrNull { it.deviceClass == device.id }?.pages?.flatMap { it.slotIds }.orEmpty()
    val slots = data.plan.slots.filter { it.key in keys }
    CanvasReviewPanel(data.project.slug, data.plan.platform, controller.version, slots, device, locale,
        selectedSlot = params.slot, selectedLayer = params.layer, saved = controller.state == DesignSaveState.CLEAN,
        canComment = canWrite, canMark = ProjectAuthority.resolve(data.project, Session.organizations).canEditStructure,
        onSelectSlot = { onParams(params.copy(slot = it, layer = null)) })
}
